module.exports = __webpack_public_path__ + "static/media/fullscreen-white-24dp.2a6c031b.svg";